/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Html5Qrcode } from "html5-qrcode";
import React, { useEffect } from "react";

const elementID = "barcode-scanner-live-stream";

interface OwnProps {
    onChange: (code: string, qty: number, uom: string) => void;
    onError: (errorMessage: string) => void;
    initHtml5QrCode: () => Promise<Html5Qrcode>;
    isOpen?: boolean;
}

type Props = OwnProps;

const ScannerModalContent = ({ onChange, onError, initHtml5QrCode, isOpen }: Props) => {
    const qrboxFunction = (viewfinderWidth: number, viewfinderHeight: number) => {
        const minEdgePercentage = 0.7; // 70%
        const minEdgeSize = Math.max(50, Math.min(viewfinderWidth, viewfinderHeight));
        const qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
        return {
            width: qrboxSize,
            height: qrboxSize,
        };
    };

    useEffect(() => {
        const qrCodeSuccessCallback = (decodedText: string, decodedResult: any) => {
            const params = decodedText?.split("@");
            const erpNumber = params[0];
            const qty = Number(params[1]);
            const uom = params[2];

            onChange(erpNumber, qty, uom);
        };

        const qrCodeErrorCallback = (errorMessage: string) => {
            if (errorMessage.indexOf("No MultiFormat Readers were able to detect the code.") < 0) {
                onError(errorMessage);
            }
        };

        const scanQRCode = async (html5QrCode: Html5Qrcode) => {
            if (!isOpen) {
                return;
            }
            try {
                await html5QrCode.start(
                    { facingMode: "environment" },
                    {
                        fps: 10,
                        qrbox: qrboxFunction,
                        aspectRatio: 1.0,
                    },
                    qrCodeSuccessCallback,
                    qrCodeErrorCallback,
                );
            } catch (errorMessage) {
                onError(errorMessage);
            }
        };

        initHtml5QrCode().then(res => {
            scanQRCode(res);
        });
    }, []);

    return <StyledWrapper id={elementID}></StyledWrapper>;
};

export default ScannerModalContent;
